var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"generic"},[_c('GenericBoxHeader',[_vm._t("header")],2),_c('div',{staticClass:"generic__body"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }